import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  orgSelectLabel: {
    height: 'auto',
    fontSize: '0.875rem',
    fontWeight: 'bold',
    color: 'var(--mui-palette-text-primary)'
  },
  orgAutocomplete: {
    '& .MuiAutocomplete-inputRoot': {
      height: 'auto'
    }
  }
}));

export default useStyles;
